import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import styles from "../css/Commentator.module.css";
import Box from "components/inputs/Box";
import { KeyboardBackspace } from "@mui/icons-material";

import { imageMimeType } from "config";
import CommentatorService from "../../service/apiConfig/CommentatorService";
import CommentatorForm from "../../components/form/CommentatorForm";
import Swal from "sweetalert2";
import checkByteSize from "../../service/util/checkByteSize";
import {commentatorActions} from "../../reducers/commentator";

const CommentatorCreate = () => {
    const history = useHistory();
    const [file, setFile] = useState(null);
    const [fileDataUrl, setFileDataUrl] = useState(null);
    const [input, setInput] = useState({
        name: '',
        nameEng: '',
        invalid: "false",
    })
    const { name, nameEng, invalid } = input;

    useEffect(() => {
        let fileReader, isCancel = false;
        if (file !== null) {
            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const { result } = e.target;
                if (result && !isCancel) {
                    setFileDataUrl(result);
                }
            };
            if (file) {
                fileReader.readAsDataURL(file);
            } else {
                fileReader.readAsDataURL(null);
            }
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }
    }, [file]);

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setInput({
            ...input,
            [name]: value
        })
    }
    const onChangeSwitch = (e) => {
        setInput({
            ...input,
            invalid: !e.target.checked
        })
    }

    const onChangeImageFileHandler = (e) => {
        e.preventDefault();
        const imageFile = e.target.files[0];
        if (!imageFile.type.match(imageMimeType)) {
            Swal.fire({
                text: "해당 형식의 파일은 지원하지 않습니다.\nJPG, PNG 파일을 등록해 주세요.",
                icon: 'warning',
                confirmButtonText: '확인',
            });
            return false;
        } else if (checkByteSize(imageFile.size)) {
            Swal.fire({
                text: `이미지 용량은 5MB 이내로 등록 가능합니다.`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                return false;
            }});
        } else {
            setFile(imageFile);
        }
    }

    const onSaveCommentator = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const commentatorData = {
            "name": name,
            "nameEng": nameEng,
            "imageAltText": "test",
            "invalid": invalid,
        }

        formData.append('commentator', JSON.stringify(commentatorData));
        formData.append('file', file);
        CommentatorService.create(formData)
            .then(response => {
                Swal.fire({
                    text: '저장이 완료되었습니다.',
                    icon: 'success',
                    confirmButtonText: '확인',
                }).then((result) => {
                    if (result.isConfirmed) {
                        history.goBack();
                    } else return false;
                })
            })
            .catch(err => console.log(err));
    }
    const handleGoBack = (e) => {
        e.preventDefault();
        if (name || nameEng || fileDataUrl) {
            Swal.fire({
                text: "입력하신 내용을 저장하지 않고\n나가시겠습니까?",
                icon: 'warning',
                confirmButtonText: '나가기',
                cancelButtonText: '취소',
                showCancelButton: true,
            }).then(r => {
                if (r.isConfirmed) {
                    history.goBack();
                }
            });
        } else {
            history.goBack();
        }
    }
    return (
        <section className={`sectionWrap ${styles.commentatorCreateWrap}`}>
            <header>
                <h2>해설자 등록</h2>
                <button onClick={(e) => handleGoBack(e)}><KeyboardBackspace /></button>
            </header>
            <Box>
                <CommentatorForm
                    name={null}
                    nameEng={null}
                    invalid={invalid}
                    imageUrl={fileDataUrl}
                    onChangeInput={onChangeInput}
                    onChangeSwitch={onChangeSwitch}
                    onChangeImageFileHandler={onChangeImageFileHandler}
                    button={true}
                    onSaveCommentator={onSaveCommentator}
                />
            </Box>
        </section>
    );
};

export default CommentatorCreate;